import { useQuery } from "@tanstack/react-query";
import type { IntegrationLogDetail } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

/**
 * Detail fetch for a single audit row. `logId` is nullable so the drawer can
 * stay mounted while closed — the query only runs once a row is selected.
 */
export function useIntegrationLogQuery(logId: string | null) {
  const query = useQuery({
    queryKey: queryKeys.admin.integrationLogById(logId ?? ""),
    queryFn: () =>
      apiJsonClient<IntegrationLogDetail>(
        endpoints.admin.integrationLogById(logId ?? ""),
      ),
    enabled: Boolean(logId),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
